var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 2.48483V4.98483M5.83337 2.48483V4.98483",
    stroke: "#F1F1F1",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 3.73483H9.16667C6.02397 3.73483 4.45262 3.73483 3.47631 4.71114C2.5 5.68746 2.5 7.2588 2.5 10.4015V12.4848C2.5 15.6275 2.5 17.1989 3.47631 18.1752C4.45262 19.1515 6.02397 19.1515 9.16667 19.1515H10.8333C13.976 19.1515 15.5474 19.1515 16.5237 18.1752C17.5 17.1989 17.5 15.6275 17.5 12.4848V10.4015C17.5 7.2588 17.5 5.68746 16.5237 4.71114C15.5474 3.73483 13.976 3.73483 10.8333 3.73483Z",
    stroke: "#F1F1F1",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91663 7.90152H17.0833",
    stroke: "#F1F1F1",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.7348C7.5 13.7348 8.75 14.1515 9.16667 15.4015C9.16667 15.4015 10.9804 12.0682 13.3333 11.2348",
    stroke: "#F1F1F1",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookings);
export default __webpack_public_path__ + "static/media/bookings.d7156a1c7352f3bbcad0cbc2b8856db9.svg";
export { ForwardRef as ReactComponent };